import React from 'react';
import AudioPlaybackControls from '../audio/AudioPlaybackControls';

type AudioPlayerType = 'message' | 'ownmessage' | 'default';

interface AudioPlayerProps {
	src: string;
	isOwnMessage?: boolean;
	type?: AudioPlayerType;
}

const COLOR_PRESETS: Record<
	AudioPlayerType,
	{ active: string; inactive: string; progressLine: string; icon: string }
> = {
	message: {
		active: '#ff6b35',
		inactive: '#9ca3af',
		progressLine: '#ff6b35',
		icon: '#000',
	},
	ownmessage: {
		active: 'rgba(255, 255, 255, 0.6)',
		inactive: 'rgba(255, 255, 255, 0.3)',
		progressLine: 'rgba(255, 255, 255, 0.8)',
		icon: 'white',
	},
	default: {
		active: '#757575',
		inactive: '#75757580',
		progressLine: '#757575',
		icon: '#000',
	},
};

const AudioPlayer = React.memo(({ src, isOwnMessage = false, type }: AudioPlayerProps) => {
	const resolvedType: AudioPlayerType = type || (isOwnMessage ? 'ownmessage' : 'message');
	const colors = COLOR_PRESETS[resolvedType];

	const bgClass =
		resolvedType === 'ownmessage' || resolvedType === 'default'
			? 'bg-transparent'
			: 'bg-gray-200 bg-opacity-50';

	return (
		<AudioPlaybackControls
			src={src}
			activeColor={colors.active}
			inactiveColor={colors.inactive}
			progressLineColor={colors.progressLine}
			iconColor={colors.icon}
			className={bgClass}
		/>
	);
});

export default AudioPlayer;
